import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { LocaleService } from '@app/locale.service';
import { ReplaySubject, Subject } from 'rxjs';
import { Currency, Hostel } from '@app/services/api/api.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-room-selection-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './room-selection-footer.component.html',
  styleUrls: ['./room-selection-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class RoomSelectionFooterComponent {
  @Input()
  public hostel: Hostel;

  @Input()
  public checkInDate: string;

  @Input()
  public checkOutDate: string;

  @Input()
  public total: any;

  @Input()
  public isLoading: boolean = false;

  @Output()
  public reserve = new EventEmitter<void>();

  public currency: ReplaySubject<Currency>;

  private destroyed = new Subject<void>();

  constructor(private readonly localeService: LocaleService) {}

  ngOnInit() {
    this.currency = this.localeService.currentCurrency;
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
